import api from './api';
import { downloadBlob, getApiErrorMessage, parseBlobError } from './blobDownload';

export async function fetchCrmMailAttachmentBlob(attachmentId) {
  const res = await api.get(`/crm/mail/attachments/${attachmentId}`, { responseType: 'blob' });
  const msg = await parseBlobError(res.data);
  if (msg) {
    throw new Error(msg);
  }
  if (!(res.data instanceof Blob) || res.data.size === 0) {
    throw new Error('Attachment file is empty or unavailable');
  }
  return res.data;
}

export async function downloadCrmMailAttachment(attachmentId, filename) {
  const blob = await fetchCrmMailAttachmentBlob(attachmentId);
  await downloadBlob(blob, filename || 'attachment');
}

export { getApiErrorMessage };
